import { useCallback, useEffect, useState } from 'react'

const pad = (n: number) => String(n).padStart(2, '0')

/** Обратный отсчёт для `429`: `label` вида «4:12», пока идёт, иначе `null`. */
export const useRetryCountdown = (): {
  secondsLeft: number
  start: (sec: number) => void
  label: string | null
} => {
  const [secondsLeft, setSecondsLeft] = useState(0)
  const running = secondsLeft > 0

  useEffect(() => {
    if (!running) return undefined
    const id = setInterval(() => setSecondsLeft((s) => Math.max(0, s - 1)), 1000)
    return () => clearInterval(id)
  }, [running])

  const start = useCallback((sec: number) => setSecondsLeft(Math.max(0, Math.ceil(sec))), [])
  const label = running ? `${Math.floor(secondsLeft / 60)}:${pad(secondsLeft % 60)}` : null
  return { secondsLeft, start, label }
}
